import { FILE_TYPE_VALUE } from '@nxsys/utils';
import { PaginationType } from '@nxsys/types/models/Common';
import type { Dayjs } from 'dayjs';

export type GetExportListParams = {
  page?: number;
  size?: number;
};

export type GetExportListResponse = {
  data: IExport[];
  pagination: PaginationType;
};

export type GetCompanyToExportParams = {
  page?: number;
  size?: number;
  sortType?: string;
  sortField?: string;
  paymentModalEmployee?: string;
  search?: string;
  companyIds?: string[];
};

export type GetCompanyToExportResponse = {
  data: any[];
  pagination: PaginationType;
};

// NX-5603: how the periods to export were picked: one or more specific
// periods, a custom range of pay dates, or all. Only the fields of that mode
// are sent; ALL sends none, which the BE reads as every period of the tax
// year.
export const EXPORT_PERIOD_MODE = {
  SPECIFIC: 'SPECIFIC',
  CUSTOM_RANGE: 'CUSTOM_RANGE',
  ALL: 'ALL',
} as const;

export type ExportPeriodMode =
  (typeof EXPORT_PERIOD_MODE)[keyof typeof EXPORT_PERIOD_MODE];

export type ExportCompanyParams = {
  ids: string[];
  fileType: (typeof FILE_TYPE_VALUE)[keyof typeof FILE_TYPE_VALUE];
  taxPeriod?: number;
  taxPeriods?: number[];
  // Pay dates, YYYY-MM-DD.
  paymentStartDate?: string;
  paymentEndDate?: string;
  taxYear?: number;
  periodMode?: ExportPeriodMode;
  // The pay dates as picked on the form.
  payDates?: [Dayjs, Dayjs] | null;
};

export type ExportCompanyResponse = {
  data: {
    message: string;
    exportId?: number;
  };
  success: boolean;
};

// NX-5603: an export is listed as soon as it is asked for, and has its file
// once the job has built it.
export const EXPORT_STATUS = {
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
} as const;

export type ExportStatus = (typeof EXPORT_STATUS)[keyof typeof EXPORT_STATUS];

export interface IExport {
  id: number;
  fileName: string;
  exportOn: string;
  linkFile: string | null;
  status: ExportStatus;
  createdAt: string;
  updatedAt: string;
  exportBy: any;
  companies: any[];
}
